/* jshint esversion: 6 */
/* jshint esversion: 8 */
import { useContext, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
const Midtrans = ({ Amount }) => {

    const { BaseUrl, setPaymentLod } = useContext(MyContext);

    const handlePayment = async () => {
        sessionStorage.setItem("Amount", Amount);

        const UserData = secureLocalStorage.getItem("LoginData");

        if (UserData) {
            const UserDetails = JSON.parse(UserData);
            await axios.post(`${BaseUrl}react_midtrans/index.php`,
                {
                    "amt": Amount,
                    "name": UserDetails.name,
                    "email": UserDetails.email,
                    "phone": UserDetails.mobile
                }
            )
                .then((res) => {
                    if (res.data.Result === "true") {
                        window.location.href = res.data.payment_url;
                        setPaymentLod(false);
                    }
                })
                .catch((error) => {
                    console.log("react_midtrans/index.php", error);
                });
        }
    };

    useEffect(() => {
        if (!Amount) return;
        handlePayment();
    }, [Amount]);

    return null;
};

export default Midtrans;